import { HttpMethod } from '@previo/core'
import { APIPaths } from '~/http/APIPaths'
import Http from '~/http/Http'
import type { GtuCodes } from '~/http/invoicing/gtuCodes/types'

export class GtuCodesAPI extends Http {
  getGtuCodes = (): Promise<GtuCodes> => {
    return this.callAuthWithPropertyAPI<null, GtuCodes>(
      HttpMethod.GET,
      {
        path: APIPaths.INVOICING_GTU_CODES,
      },
      null,
    )
  }
}
